<kt-loader [showLoader]="loading()">
  <form class="kt-form__section mt-2" (ngSubmit)="savePersonalDetail()">

    <div class="kt-heading kt-heading--md kt-heading--space-sm"> {{'EMPLOYEE.PROFILE_DETAILS' | translate}}
    </div>

    <!-- Body start -->
    <div class="kt-wizard-v2__form">

      <div>
        <div class="form-group row">
          <!-- sub field list loop start-->
          <div class="col-md-6 kt-widget">
            <!-- render  profile-upload component start-->
            <kt-profile-upload [isLoggedInUserProfile]="isLoggedInUserProfile"  [field]="employeeProfileImageControl" [form]="_personalDetailform"
              [options]="lookup[employeeProfileImageControl.key]">
            </kt-profile-upload><br>
            <!-- render  profile-upload component end-->
            <kt-signin-device-info [employeeDetails]="_employeeData">
            </kt-signin-device-info>
          </div>
          <div class="col-md-6" *ngIf="_enableShiftControl">
            <!-- render  profile-upload component start-->
            <div *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.MANAGE_OTHER_SHIFT_ACCESS : PermissionV2.MANAGE_OWN_SHIFT_ACCESS">
  
                <label>Shift Control</label>
                <div *ngIf="activeScreen.mainScreen" class="kt-widget kt-widget--user-profile-1 wrapper d-table-cell">
                  <kt-shift-control [selectedUserData]="_employeeData" [where]="'personal'"></kt-shift-control>
                </div>
  
            </div>
            <!-- render  profile-upload component end-->
          </div>
        </div>
      </div>

      <kt-formly [form]="_personalDetailform" [fieldList]="formConstants" [options]="lookup"
        [values]="{user_business_marital_status: null}" (valueChange)="valueChangeHandler($event)">
      </kt-formly>
    </div>
    <!-- Body end -->

    <!-- Footer start -->
    <div class="modal-footer d-flex justify-content-between align-items-center">
      <div *ngIf="loginUserRole !== Role?.Client">
        <ng-container  *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_SENSITIVE_DETAILS_ACCESS : PermissionV2.SELF_PEOPLE_SENSTIVE_DETAILS_ACCESS">
          <div>
          <!--old condition (loginUserRole === Role?.System_Administrator || (loginUserRole !== Role?.System_Administrator && _employeeData?.employee_id && (_employeeData?.employee_id == loginEmployeId))) && _employeeData?.employee_fk_user_id" -->
            <button type="button" class="btn btn-brand btn-wide" (click)="kioskClickHandler()">
              Kiosk PIN
            </button>
          </div>
        </ng-container>
      </div>

      <ng-container
      *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_GENERAL_DETAILS_MANAGE : null">
        <div>
          <span>
            <button *ngIf="_employeeData?.employee_id && !(_employeeData?.employee_id == loginEmployeId)" type="button"
              class="btn btn-label-danger btn-bold me-2" (click)="archiveClickHandler()">
              Archive
            </button>
          </span>
          <button type="submit" class="btn btn-brand false"
            [disabled]="_personalDetailform?.get('_uploading')?.value">Save
            Personal Detail</button>
        </div>
      </ng-container>
    </div>
    <!-- Footer end -->

  </form>
</kt-loader>
